import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import DialogInterface from '@/interfaces/dialog';
import template from '@/../templates/development-devicegroup-settings.hbs';

    var MAX_DESCRIPTION_LENGTH = 300;
    var MAX_NAME_LENGTH = 100;

    var globalCh = Radio.channel('global');

    function perm_check(active, primary, type){
        if ( type === 'development_devicegroup' && active.permits(primary, 'update_development_vars') ) {
            return true;
        }
        return false;
    }

    var EditDeviceGroupDialog = Marionette.View.extend(DialogInterface).extend({
        template: Handlebars.compile(template),
        ui: {
            name: '.form-control.name',
            description: '.form-control.description',
            submit_btn: '.submit',
            load_spinner: '.loader',
            description_length_counter: '.description-counter',
            name_length_counter: '.name-counter',
            cancel: '.cancel',
            devicegroup_profile: '.devicegroup-profile',
            tooltips: '[data-toggle="tooltip"]',
            env_vars: '.environment-variables',
            env_vars_textarea: '.environment-variables textarea'
        },
        events: {
            'submit form': 'handle_submit',
            'keyup @ui.description': 'validate_description',
            'paste @ui.description': 'validate_description',
            'change @ui.description': 'validate_description',
            'mouseup @ui.description': 'validate_description',
            'keyup @ui.name': 'validate_name',
            'paste @ui.name': 'validate_name',
            'change @ui.name': 'validate_name',
            'mouseup @ui.name': 'validate_name',
        },
        initialize: function (options) {
            this.destroyOnClose();
            this.focusFirstInput();
            this.owner = Radio.request('global', 'active_account');
        },
        validate_description: function () {
            this.trigger('input');
            this.check_validation(
                this.ui.description,
                MAX_DESCRIPTION_LENGTH,
                this.ui.description_length_counter
            );
        },
        validate_name: function () {
            this.trigger('input');
            this.check_validation(
                this.ui.name,
                MAX_NAME_LENGTH,
                this.ui.name_length_counter
            );
            if (this.ui.name.val()) {
                this.ui.submit_btn.prop('disabled', false);
            } else {
                this.ui.submit_btn.prop('disabled', true);
            }
        },
        templateContext: function () {
            let self = this;
            var active = globalCh.request('active_account');
            var primary = globalCh.request('primary_account');

            let devicegroup_profiles = JSON.stringify(this.owner.devicegroup_profiles);
            if ( devicegroup_profiles ) devicegroup_profiles = JSON.parse(devicegroup_profiles);

            let current_devicegroup_profile = undefined;

            if ( this.model && this.model.rel.get('profile') && devicegroup_profiles ) {
                current_devicegroup_profile = devicegroup_profiles.find(
                    function(p){
                        return p.id ===  self.model.rel.get('profile').id;
                    }
                );
                current_devicegroup_profile.selected = true;
            }
            let env_vars = null;
            let env_vars_keys = null;
            let edit_env_vars = false;
            let show_env_vars_keys = false;
            
            if ( this.model && this.model.get('env_vars') ) { 
                env_vars = JSON.stringify(this.model.get('env_vars'), null, 4);
            }
            if ( perm_check( active, primary, 'development_devicegroup') ) {
                edit_env_vars = true;
            } else {
                show_env_vars_keys = true;
                if ( this.model && this.model.get('env_vars') ) {
                    env_vars_keys = Object.keys(this.model.get('env_vars'));
                }
            }
            if ( !env_vars_keys ) env_vars_keys = "no variables";

            return {
                dialog_title: this.getOption('dialog_title'),
                name: this.getOption('name'),
                name_label: this.getOption('name_label'),
                description_label: this.getOption('description_label'),
                cancel_text: this.getOption('cancel_text') || 'Cancel',
                submit_text: this.getOption('submit_text') || 'Submit',
                devicegroup_profiles: devicegroup_profiles,
                show_env_vars_keys: show_env_vars_keys,
                edit_env_vars: edit_env_vars,
                env_vars: env_vars,
                env_vars_keys: env_vars_keys,
            };
        },
        onRender: function () {
            this.ui.tooltips.tooltip();
            if ( this.model ) {
                this.ui.name.val(this.model.get('name'));
                this.ui.description.val(this.model.get('description'));
                this.validate_name();
                this.validate_description();
            }
        },
        handle_submit: function(e){
            let active = globalCh.request('active_account');
            let primary = globalCh.request('primary_account');

            if ( e ) {
                e.preventDefault();
            }
            let devicegroup_profile = this.ui.devicegroup_profile.val();
            let profile = null;
            this.ui.load_spinner.show();
            if ( this.owner.devicegroup_profiles == undefined || devicegroup_profile == '' ) {
                profile = null;
            } else {
                profile = this.owner.devicegroup_profiles.find(
                    function(p){
                        return p.id === devicegroup_profile;
                    }
                );
                profile = {
                    id: profile.id,
                    type: profile.type
                };
            }
            let env_vars_string = this.ui.env_vars_textarea.val();
            let env_vars = null;
            try {
                env_vars = JSON.parse(env_vars_string);
            } catch ( e ) {
                if (  env_vars_string && env_vars_string.length > 0 ) {
                    let error = {
                        responseJSON : {
                            errors: [
                                { detail: e }
                            ]
                        }
                    };
                    this.handle_error(error);
                    return;
                }
            }

            

            if ( !this.model ) {
                let opts = {
                    name: this.ui.name.val(),
                    description: this.ui.description.val(),
                    type: this.collection.TYPES_MAP.development
                };

                if ( perm_check(active, primary, opts.type) ) {
                        opts.env_vars = env_vars;
                }


                this.collection.create(
                    opts,
                    {
                        creator: this.options.product.rel.get('owner'),
                        owner: this.owner,
                        profile: profile,
                        product: this.getOption('product'),
                        wait: true,
                        success: function(model){ this.on_success(model); }.bind(this),
                        error: function (model, response) { this.handle_error(response); }.bind(this)
                    }
                );

            } else {
                let attributes = {
                    name: this.ui.name.val(),
                    description: this.ui.description.val()
                };

                if ( perm_check(active, primary, this.model.type) ) {
                        attributes.env_vars = env_vars;
                }

                this.model.save({
                    data: {
                        type: this.model.type,
                        id: this.model.id,
                        attributes: attributes,
                        relationships: {
                            profile: profile
                        }
                    }
                },
                {
                    patch: true,         
                })
                .done(function(){
                    this.handle_success();
                }.bind(this))
                .fail(function(e){
                    this.handle_error(e);
                }.bind(this));
            }
        },
        handle_success: function(){
            var globalCh = Radio.channel('global');
            this.ui.load_spinner.hide();
            this.closeDialog();
            globalCh.request(
                'layout_alert', 
                'Successfully updated ' + this.model.get('name') + '.', 'success', 4000);
        },
        on_success: function (devicegroup) {
            var globalCh = Radio.channel('global');
            Radio.request('alerts', 'showAlert', {
                message: 'Successfully created new Development Device Group: "' +
                devicegroup.get('name') + '"',
                messageType: 'success'
            });
            this.closeDialog();
            globalCh.request('showCodeEditor',
            devicegroup.draft,
            devicegroup);
        },
        handle_error: function(err){
            this.showAlert('failure', err);
            this.ui.load_spinner.hide();
            this.listenToOnce(this, 'input', function(){
                this.hideAlert();
            }.bind(this));
        }
    });
    export default EditDeviceGroupDialog;

